import Vue from 'vue';
import { onMounted, ref } from '@vue/composition-api';
import { required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import useIsFieldValid from '@/hooks/useIsFieldValid';
import CommonLabel from '@/components/common/CommonLabel.vue';
import ErrorMessage from '@/components/common/ErrorMessage.vue';
export default Vue.extend({
    name: 'FavouriteOptions',
    components: { CommonLabel, ErrorMessage },
    props: {
        value: {
            type: String,
            required: false
        },
        label: {
            type: String,
            required: true
        },
        ariaLabel: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        options: {
            type: Array,
            required: true
        },
        mandatory: {
            type: Boolean,
            default: false
        },
        mandatoryErrMsg: {
            type: String,
            required: false
        },
        hint: {
            type: String,
            required: false
        },
        id: {
            type: String,
            required: true
        },
        width: {
            type: String,
            required: false,
            default: 'full',
            validator: (v) => ['half', 'full'].includes(v)
        }
    },
    setup(props, context) {
        const inputValue = ref(props.value);
        const sortedOptions = props.options.sort((option1, option2) => Number(option1.order) - Number(option2.order));
        let allOptions;
        const rules = {
            inputValue: {
                ...(props.mandatory && { required })
            }
        };
        const $v = useVuelidate(rules, { inputValue });
        const handlePress = (e) => {
            const target = e.target;
            if (target.id === inputValue.value) {
                target.classList.remove('c-favourite-options__option--selected');
                context.emit('update:value', null);
                inputValue.value = null;
            }
            else {
                target.classList.add('c-favourite-options__option--selected');
                context.emit('update:value', target.id);
                inputValue.value = target.id;
            }
            allOptions.forEach((el) => {
                if (target.id !== el.id) {
                    el.classList.remove('c-favourite-options__option--selected');
                }
            });
            $v.value.inputValue.$touch();
        };
        const setInitialValue = () => {
            allOptions.forEach((element) => {
                if (inputValue.value === element.id) {
                    element.classList.add('c-favourite-options__option--selected');
                }
            });
        };
        const addMarginOnLineBreak = () => {
            const firstElement = allOptions[0];
            allOptions.forEach((element) => {
                element.getBoundingClientRect().top !== firstElement.getBoundingClientRect().top
                    ? element.classList.add('c-favourite-options__option--margin')
                    : element.classList.remove('c-favourite-options__option--margin');
            });
        };
        onMounted(() => {
            allOptions = context.refs.optionsRef;
            addMarginOnLineBreak();
            setInitialValue();
            window.addEventListener('resize', addMarginOnLineBreak);
        });
        const isFieldValid = () => useIsFieldValid($v, 'inputValue');
        return {
            handlePress,
            sortedOptions,
            $v,
            isFieldValid
        };
    }
});
